import { render, staticRenderFns } from "./FeedbackContainer.vue?vue&type=template&id=877a4a3c&"
import script from "./FeedbackContainer.vue?vue&type=script&lang=js&"
export * from "./FeedbackContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stevetentrop/workspace/localsystem/plugins/inbox/set_plugins/1/Feedback/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('877a4a3c')) {
      api.createRecord('877a4a3c', component.options)
    } else {
      api.reload('877a4a3c', component.options)
    }
    module.hot.accept("./FeedbackContainer.vue?vue&type=template&id=877a4a3c&", function () {
      api.rerender('877a4a3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/singleitem/FeedbackContainer.vue"
export default component.exports